<template>
  <div class="bg-white p-4 rounded-xl">
    <div
      :class="`d-lg-flex ${
        filterDate ? 'justify-content-between' : 'justify-content-end'
      }`"
    >
      <div v-if="filterDate">
        <div
          class="d-lg-flex d-flex gap-3 mb-2 mb-lg-0 align-items-center justify-content-between w-100"
        >
          <div class="text-left w-100">
            <label for="" class="">Start Date</label>
            <BFormInput
              type="date"
              placeholder="dd/mm/yyyy"
              class=""
              :model-value="startDate"
              @update:modelValue="$emit('update:startDate', $event)"
            ></BFormInput>
          </div>
          <!-- :value="startDate" @input="$emit('update:startDate', $event.target.value)" -->
          <div class="text-left w-100">
            <label for="" class="">End Date</label>
            <BFormInput
              type="date"
              class=""
              :model-value="endDate"
              @update:modelValue="$emit('update:endDate', $event)"
            ></BFormInput>
          </div>
          <slot name="left-filters"></slot>
        </div>
      </div>
      <div
        :class="`d-lg-flex align-items-center ${
          cta ? 'gap-lg-3 justify-content-end' : 'justify-content-end'
        }`"
      >
        <div class="d-flex gap-3 mb-2 mb-lg-0 align-items-center">
          <BButton
            v-if="filterModal"
            class="btn-filter d-lg-flex d-flex align-items-center align-items-lg-center mb-lg-0"
            variant="light"
            @click="$emit('showFilter')"
          >
            <i class="fas fa-filter me-1"></i>
            <span class="">Filter</span>
          </BButton>
          <BInputGroup class="border rounded-lg">
            <template #append>
              <BButton variant="white"
                ><i class="ios ion-ios-search text-black"></i
              ></BButton>
            </template>

            <BFormInput
              type="text"
              class="border-0"
              placeholder="Search"
              v-model="searchQuery"
            />
          </BInputGroup>
        </div>
        <div class="d-grid" v-if="cta && ctaText">
          <BButton
            v-if="cta"
            class="btn-cta"
            variant="primary"
            @click="$emit('action')"
          >
            <i class="fas fa-plus"></i>
            {{ ctaText }}
          </BButton>
        </div>
        <div
          v-if="showExport"
          class="d-flex align-items-center gap-2"
        >
          <BButton variant="secondary" class="ms-3" 
            @click="$emit('export')">
            <i class="fas fa-download"></i>
            Export
          </BButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // BRow,
  // BCol,
  BButton,
  BFormInput,
  BInputGroup,
} from "bootstrap-vue-next";
import { computed, watch } from "vue";

export default {
  name: "ActionContent",
  components: {
    // BRow,
    // BCol,
    BButton,
    BFormInput,
    BInputGroup,
  },
  props: {
    ctaText: String,
    filterDate: {
      type: Boolean,
      default: true,
    },
    startDate: {
      type: String,
      required: false,
    },
    endDate: {
      type: String,
      required: false,
    },
    filterModal: {
      type: Boolean,
      default: true,
    },
    cta: {
      type: Boolean,
      default: true,
    },
    search: {
      type: String,
      default: "",
    },
    showExport: {
      type: Boolean,
      default: false
    },
  },
  emits: ["search-query", "update:search", "update:startDate", "update:endDate"],
  setup(props, { emit }) {
    const searchQuery = computed({
      get: () => props.search,
      set: (val) => {
        emit("update:search", val); // cara baru (v-model:search)
        emit("search-query", val);  // cara lama (kompatibilitas)
      },
    });

    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };

    const emitSearchQuery = debounce(() => {
      emit(
        "search-query",
        searchQuery.value.trim().length >= 2 ? searchQuery.value.trim() : ""
      );
    }, 300);

    watch(searchQuery, () => {
      emitSearchQuery();
    });

    return {
      searchQuery,
    };
  },
};
</script>

<style>
@media screen and (min-width: 768px) {
  .col-lg-4 {
    min-width: 184px;
  }
}
</style>
